<div class="container-padded">
  <div class="inner-content card">
    <span class="filters-section">
      <form>
        <mat-form-field appearance="outline" class="string-filter-field">
          <input matInput test-id="filter-input" [formControl]="$any(form.get('searchString'))" [placeholder]="'projectCatalog.labels.searchString' | translate">
        </mat-form-field>

        <span *ngIf="projectTags.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.projectTags' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(projectTags)"
            [formControl]="$any(form.get('projectTags'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="therapeuticAreaFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.therapeuticAreas' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(therapeuticAreaFilters)"
            [formControl]="$any(form.get('therapeuticAreas'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="bodyRegionFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.bodyRegions' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(bodyRegionFilters)"
            [formControl]="$any(form.get('bodyRegions'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="organSystemFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.organSystem' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(organSystemFilters)"
            [formControl]="$any(form.get('organSystems'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="ageFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.age' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(ageFilters)"
            [formControl]="$any(form.get('ageFilters'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="fileTypeFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.fileTypes' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(fileTypeFilters)"
            [formControl]="$any(form.get('fileTypeFilters'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="modalityFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.modality' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(modalityFilters)"
            [formControl]="$any(form.get('modalities'))">
          </fw-chip-selector>
        </span>

        <span *ngIf="measurementFilters.length > 0">
          <span class="filter-section-header">{{ 'projectCatalog.labels.measurementScan' | translate }}</span>
          <fw-chip-selector
            [chipsToShow]="7"
            [options]="$any(measurementFilters)"
            [formControl]="$any(form.get('measurementAndScanTags'))">
          </fw-chip-selector>
        </span>
      </form>
    </span>
    <span class="project-list-section">
      <ng-container *ngIf="projectList.length > 0; else emptyState">
        <mat-card appearance="outlined" *ngFor="let project of projectList; index as projectIndex">
          <mat-card-content>
            <span class="project-summary">
              <span class="avatar-and-contact">
                <span
                  class="avatar"
                  [style.backgroundColor]="project.avatarColor"
                  [style.backgroundSize]="'cover'">
                  {{ project.avatarInitials }}
                </span>
                <span class="project-label">
                  <!-- TODO: Once share_level and full_ro_access are available, create link to project -->
                  <!-- <a test-id="project-catalog-label" href="#/projects/{{ project.id }}/description">{{ project.label }}</a> -->
                  {{ project.label }}
                  <span class="contact-information">
                    <a href="{{ project.project_institutions[0].url }}" target="_blank" rel="nofollow noopener">{{ project.project_institutions[0].name }}</a>
                    <a href="mailto:{{ project.project_contacts[0].email }}" target="_blank">{{ project.project_contacts[0].email }}</a>
                  </span>
                </span>
              </span>

              <span class="project-description">
                <span *ngIf="project.truncatedSummary !== project.summary; else shortSummary">
                  {{ project.readMore ? project.truncatedSummary : project.summary }} <span *ngIf="project.readMore">...</span>
                  <a type="button" (click)="project.readMore = !project.readMore">
                    {{ project.readMore ? 'Read More': 'Read Less' }}
                  </a>
                </span>
                <ng-template #shortSummary>
                  <span>{{ project.summary }}</span>
                </ng-template>
              </span>
            </span>

            <span class="project-metadata">
              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.subjects ?  project?.stats.number_of.subjects : '-' }}
                </span>
                <span class="metadata-label">
                  {{ 'common.labels.subjects' | translate }}
                </span>
              </span>

              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.sessions ?  project?.stats.number_of.sessions : '-' }}
                </span>
                <span class="metadata-label">
                  {{ 'common.labels.sessions' | translate }}
                </span>
              </span>

              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.acquisitions ?  project?.stats.number_of.acquisitions : '-' }}
                </span>
                <span class="metadata-label">
                  {{ 'common.labels.acquisitions' | translate }}
                </span>
              </span>

              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.files ?  project?.stats.number_of.files : '-' }}
                </span>
                <span class="metadata-label">
                {{ 'common.labels.files' | translate }}
                </span>
              </span>
            </span>
          </mat-card-content>
          <mat-card-footer>
            <mat-chip-listbox>
              <mat-chip-option *ngFor="let tag of project.chips" class="gray-chip">{{ tag }}</mat-chip-option>
            </mat-chip-listbox>
          </mat-card-footer>
        </mat-card>
        <div (fwLoadTrigger)="loadMore$.next()" class="load-trigger"></div>
      </ng-container>

      <ng-template #emptyState>
        <div class="blank-state">
          <p>{{ 'projectCatalog.labels.emptyState' | translate }}</p>
        </div>
      </ng-template>
    </span>
  </div>
</div>
